import { Gig } from "../../../Models/Gig";
import { BaseAPICallsHandler } from "../BaseAPICallsHandler";
import { NetworkUtils } from "../NetworkUtils";
import { ServerConfig } from "../ServerConfig";

export interface GigsResponse {
    gigs: Gig[];
    pageNumber: number;
    pageSize: number;
    totalGigs: number;
}

export class GigAPIHandler {
    
    public static shared = new GigAPIHandler()
    
    apiHandler = BaseAPICallsHandler.shared
    serverConfig = ServerConfig.shared
    networkUtils = NetworkUtils.shared

    // dependency injection here
    constructor();
    constructor(apiHandler: BaseAPICallsHandler, serverConfig: ServerConfig, networkUtils: NetworkUtils);
    public constructor(...params: any[]) {
        if(params.length >= 3) {
            this.apiHandler = params[0];
            this.serverConfig = params[1];
            this.networkUtils = params[2];
        }
    };

    public async createGig(gigFormData: any) {

        let createGigUrl = this.serverConfig.gigAPIS.createGigAPI
        let authHeaders = this.networkUtils.addAuthHeaders({});

        try {

            let gigResponse = await this.apiHandler.makePostRequest(authHeaders, createGigUrl, gigFormData);
            let gigData = gigResponse.data.gig
            let gig = new Gig(gigData);
            return Promise.resolve(gig);

        } catch (err) {
            return Promise.reject(err);
        }
    }

    public async editGig(gigId: string, gigFormData: any) {

        let createGigUrl = this.serverConfig.gigAPIS.editGigAPI + gigId
        let authHeaders = this.networkUtils.addAuthHeaders({});

        try {

            let gigResponse = await this.apiHandler.makePutRequest(authHeaders, createGigUrl, gigFormData);
            let gigData = gigResponse.data.gig
            let gig = new Gig(gigData);
            return Promise.resolve(gig);

        } catch (err) {
            return Promise.reject(err);
        }
    }

    public async getGigById(Id: String): Promise<Gig> {
        let url = this.serverConfig.gigAPIS.getGigByIDAPI + Id;
        
        try {
            
            let response = await this.apiHandler.makeGetRequest({}, url);
            let data = response.data.gig;
            let gig = new Gig(data);
            return Promise.resolve(gig);

        } catch (err) {
            return Promise.reject(err);
        }
    }

    public async deleteGigById(gigId: string) {
        let url = this.serverConfig.gigAPIS.deleteGigsByIDAPI + gigId;
        let authHeaders = this.networkUtils.addAuthHeaders({});

        try {
            let response = await this.apiHandler.makeDeleteRequest(authHeaders, url, undefined);
            let responseMessage = response.data.message;
            return Promise.resolve(responseMessage);
            
        } catch (error) {
            return Promise.reject(error);
        }
    }

    public async getGigsBySeller(Id: String): Promise<Gig[]> {
        let url = this.serverConfig.gigAPIS.getGigsBySellerAPI + Id;
        
        try {
            
            let response = await this.apiHandler.makeGetRequest({}, url);
            let data = response.data.gigs as Array<any>;
            let gigArray = data.map((gigJson) => {
                return new Gig(gigJson);
            }) 
            return Promise.resolve(gigArray);

        } catch (err) {
            return Promise.reject(err);
        }
    }

    public async getGigsBySubcategory(Id: String, pageNumber: Number = 1, pageSize: Number = 20): Promise<GigsResponse> {
        let queryParams = new URLSearchParams();
        queryParams.append('pageNumber', pageNumber.toString());
        queryParams.append('pageSize', pageSize.toString());
    
        let url = this.serverConfig.gigAPIS.getGigsBySubcategoryAPI + Id + `?${queryParams.toString()}`;
    
        try {
            let response = await this.apiHandler.makeGetRequest({}, url);
            let data = response.data.gigs as Array<any>;
    
            let gigArray = data.map((gigJson) => {
                return new Gig(gigJson);
            });
    
            let responseToSendBack: GigsResponse = {
                gigs: gigArray,
                pageNumber: response.data.pageNumber,
                pageSize: response.data.pageSize,
                totalGigs: response.data.totalGigs
            };
    
            return Promise.resolve(responseToSendBack);
        } catch (err) {
            return Promise.reject(err);
        }
    }
    
}